import { render, staticRenderFns } from "./PlacementForm.tmplacements.vue?vue&type=template&id=64110f88&scoped=true&lang=html&"
import script from "./PlacementForm.tmplacements.vue?vue&type=script&lang=js&"
export * from "./PlacementForm.tmplacements.vue?vue&type=script&lang=js&"
import style0 from "./PlacementForm.tmplacements.vue?vue&type=style&index=0&id=64110f88&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64110f88",
  null
  
)

export default component.exports